import React, { Fragment } from 'react'
import { Intro, MultipleChoice } from 'cvs-core'

const data = {
  question:
    'Which of the following is NOT an example of how vape companies use misleading advertising practices to increase the market for their product?',
  inputType: 'radio',
  options: [
    {
      label: 'Websites state that vaping can help you quit smoking.',
    },
    {
      label:
        'Marketing flavors that appeal to kids, like bubblegum, for e-liquid products.',
    },
    {
      label: 'Companies promote e-cigarettes as being safe.',
    },
    {
      label:
        'Include warnings on products about the addictive chemical nicotine.',
    },
  ],
}

const correctInput = {
  [data.question]: data.options[3].label,
}

const feedback = {
  success: {
    title: 'Great job!',
    body: '',
  },
  error: {
    title: 'That’s incorrect.',
    body: '',
  },
  retry: {
    title: 'Not quite, give it another try',
    body: '',
  },
}

export default {
  title: 'Question 1',
  path: '/challenge/question-1',
  content: (
    <Fragment>
      <Intro
        title="Question 1"
        direction="Select the item that best completes the statement."
      />
      <MultipleChoice
        data={data}
        correctInput={correctInput}
        feedback={feedback}
        score={10}
        partiallyCorrectScoring={true}
      />
    </Fragment>
  ),
}



// WEBPACK FOOTER //
// ./src/data/Challenge/Question1.js